import Field, { Label } from "@components/inputs/field";
import FieldsWrapper from "@components/inputs/field/FieldsWrapper";
import Input from "@components/inputs/input";
import SmartField, { ISmartFieldProps, ISmartFieldRenderProps } from "@components/smart/smartField/SmartField";
import { ISmartFieldEvents } from "@components/smart/smartField/SmartFieldUtils";
import { IPrPayslipEntity, PrPayslipDeductionEntity, PrPayslipEntity } from "@odata/GeneratedEntityTypes";
import { PrPayslipItemTypeCode } from "@odata/GeneratedEnums";
import { DeductionsWrapper } from "@pages/payroll/payslip/Payslip.styles";
import { isCustomPayslipDeduction } from "@pages/payroll/payslip/Payslip.utils";
import { getCompanyCurrency } from "@utils/CompanyUtils";
import memoizeOneWithParamsCheck from "@utils/memoizeOne";
import i18next from "i18next";
import React, { Component } from "react";

import { LabelStatus } from "../../../enums";
import { formatCurrency } from "../../../types/Currency";
import { FormStorage } from "../../../views/formView/FormStorage";

export interface IProps extends Omit<ISmartFieldRenderProps, "onBlur" | "onChange" | "onRowsChange">, ISmartFieldEvents {
    storage: FormStorage<IPrPayslipEntity>;
}

export default class DeductionsEntryList extends Component<IProps> {

    getFieldProps = memoizeOneWithParamsCheck((): ISmartFieldProps['fieldProps'] => {
        return {
            labelStatus: LabelStatus.Removed,
            isWithoutRightMargin: true,
        };
    });

    formatAmount(amount: number): string {
        return formatCurrency(amount, getCompanyCurrency(this.props.storage.context));
    }

    render() {
        const { storage } = this.props;
        const payslip = storage.data.entity as IPrPayslipEntity;
        const deductions = storage.data.entity.Deductions?.filter(isCustomPayslipDeduction);
        const deductionsBc = storage.data.bindingContext.navigate(PrPayslipEntity.Deductions);
        const fieldProps = this.getFieldProps();
        const netSalary = payslip.Items.find(i => i.TypeCode === PrPayslipItemTypeCode.NetSalary)?.DecimalValue;

        return (
                <DeductionsWrapper>
                    <FieldsWrapper>
                        <Field label={i18next.t("Payslip:Deductions.Base")} isReadOnly>
                            <Input value={this.formatAmount(netSalary)} name={"deductions-base"} isReadOnly/>
                        </Field>
                    </FieldsWrapper>
                    {deductions.map((deduction, index) => {
                        const { storage, onWidthChange, ...restProps } = this.props;
                        const bc = deductionsBc.addKey(deduction);
                        return (
                                <React.Fragment key={deduction.Id}>
                                    <Label isRequired>{deduction.Name}</Label>
                                    <SmartField storage={storage}
                                                bindingContext={bc.navigate(PrPayslipDeductionEntity.AmountOverride)}
                                                fieldProps={fieldProps}
                                                {...restProps} />
                                    <div>{/* keep the div as the field becomes invisible sometime, but we need to keep the grid */}
                                        <SmartField storage={storage}
                                                    bindingContext={bc.navigate(PrPayslipDeductionEntity.CalculationTypeCode)}
                                                    fieldProps={fieldProps}
                                                    {...restProps} />
                                    </div>
                                </React.Fragment>
                        );
                    })}
                </DeductionsWrapper>
        );
    }
}
